import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthBllService } from '../auth-bll.service';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { LoaderService } from '../../../shared/components/loader/loader.service';


/**
 * Component for handling link-based login functionality.
 * 
 * This component retrieves the authorization key from the query parameters,
 * processes the link click using the authentication service, and manages
 * loading indicators during the process. It also handles errors that may
 * occur during the login process and navigates the user accordingly.
 *
 * @component
 * @example
 * <app-link-login></app-link-login>
 */
@Component({
  selector: 'app-link-login',
  imports: [CommonModule, LoaderComponent],
  templateUrl: './link-login.component.html',
  styleUrl: './link-login.component.scss'
})
export class LinkLoginComponent {

  error: string | null = null;
  private loaderService = inject(LoaderService);

  constructor(
    private route: ActivatedRoute,
    private authService: AuthBllService,
    private router: Router
  ) {}

  /**
    * Initializes the component by showing the loader service and processing the link click.
    * It subscribes to the query parameters to retrieve the authorization key.
    * If the authorization key is missing, it navigates to the home page.
    * If the key is present, it attempts to process the link click and handle any errors that may occur.
    * Finally, it hides the loader service regardless of the outcome.
    */
  ngOnInit(): void {
    this.loaderService.show();
    this.route.queryParams.subscribe((params) => {
      const authKey = params['id'];
      const isGallabox = params['is_gallabox'];
      if ( !authKey) {
        // Missing required OAuth parameters
        // this.error = 'Missing authorization parameters.';
        // return;
        this.router.navigate(["home"], { replaceUrl: true })
      }
      this.authService
        .processLinkClick(authKey, isGallabox)
        .then(() => {
          console.log('Link login successful, redirecting to home...');
        })
        .catch((err: any) => {
          // Log and display any error during token exchange
          console.error(err);
          this.error = err.message || 'Login failed';
          this.router.navigate(["home"]);
        })
        .finally(() => {
          // Always stop the loading indicator
          this.loaderService.hide();
        });
    });
  }

}
